import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { ListingFilter } from '@df/catalog-ui/listing/listing';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { IProductData, IProductDataV2, Product } from '@df/catalog/product/product';
import { IResourceIndex } from '@df/catalog/resource';

export interface IFilterStockOption extends Catalog.IAttributeOption {
    checkProduct(product: Product<IProductData>): boolean;
}
export const IN_STOCK_FILTER_ID = 'in_stock_filter';
@ListingFilter({
    filterType: 'stock'
})
export class FilterStock<T extends Product<IProductData>> extends FilterAttributeOption<T> {
    protected indexes?: IResourceIndex

    override get options() {
        return [
            {
                value: 1,
                label: this.getOptionLabel(),
                checkProduct: (product: Product<IProductData>): boolean => {
                    if ((product?.data as IProductDataV2)?.isBanner) {
                        return false;
                    }
                    return (product?.stock?.data?.qty || 0) > 0;
                }
            }
        ];
    }
    override getOptionLabel(): string {
        const label = this.attribute?.data?.options?.[0]?.label;
        if (label && typeof label === 'string') {
            return label;
        }
        return 'In Stock';
    }
    /**
     * Gets index related to attribute from `Resource`
     */
    override getIndex(): IResourceIndex  {
        if (!this.indexes) {
            const index = {};
            this.options?.forEach(option => {
                const optionIndex = {};
                this.listing.getSourceModels().forEach(product => {
                    const checkResult = option.checkProduct(product);
                    if (!checkResult) {
                        this.app.logger.log(product);
                    }
                    if (checkResult) {
                        optionIndex[product.id] = true;
                    }
                });
                index[option.value] = optionIndex;
            });
            this.indexes = index;
        }
        return this.indexes;
    }
}
